import AbbiApi from '@/apis/abbi.api';

export default class ShortCodeApi extends AbbiApi {
    public static resolve(code: string) {
        return ShortCodeApi.post(`${AbbiApi.url}/shortcode/${code}`, {});
    }
}
